<template>
  <data-table-loader v-if="loader" />
  <!-- Table Container Card -->
  <b-row v-else>
    <b-col
      md="8"
      sm="12"
      offset-md="2"
    >
      <b-card>
        <b-card-title> {{ $t('Import from csv') }}</b-card-title>
        <validation-observer
          ref="importContactForm"
          #default="{ invalid }"
        >
          <b-form @submit.prevent="importContacts">
            <b-form-group
              :label="$t('Contact group')"
            >

              <validation-provider
                #default="{ errors }"
                :name="$t('Contact group')"
                vid="group"
                rules="required"
              >
                <v-select
                  v-model="group"
                  :options="groups"
                  label="name"
                  :reduce="_group => _group.id.toString()"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Contact group')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                :name="$t('file')"
                vid="file"
                rules="required|attachment:text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet|file-size:3"
              >
                <b-form-file
                  v-model="file"
                  accept="text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :placeholder="$t('Choose a file or drop it here')"
                  :drop-placeholder="$t('Drop file here')"
                />
                <b-card-text
                  v-if="file !== null"
                  class="my-1"
                >
                  {{ $t('Selected file') }} : <strong>{{
                    file.name | summaryText(60)
                  }}</strong><br><strong>{{ $t('File size') }} : {{ file.size | humanFileSize }}</strong>
                </b-card-text>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group v-if="spin && file !== null">
              <b-progress
                :value="fileProgress"
                rtl
                max="100"
                :precision="2"
                show-value
                variant="primary"
                class="progress-bar-primary"
              />
            </b-form-group>
            <b-form-group>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                :disabled="invalid || spin"
                class="float-right"
              >
                {{ $t("save") }}
                <feather-icon
                  v-if="!spin"
                  icon="UploadCloudIcon"
                  size="15"
                />
                <b-spinner
                  v-if="spin"
                  small
                />
              </b-button>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card>
      <b-card>
        <b-card-body>
          <b-card-text>
            <ul>
              <li>ردیف اول فایل اکسل به نام داده ها اختصاص دارد</li>
              <li>            نام داده باید به ترتیب، ستون اول نام و نام خانوادگی، ستون دوم شماره موبایل، ستون سوم شهر، ستون چهارم شرکت، ستون پنجم جنسیت (آقا 1/خانم 2)، ستون ششم  تاریخ تولد می باشد.
              </li>
              <li><span class="text-danger">نام ستون دوم بایستی phone باشد، در غیر این صورت فایل شما وارد نمی شود</span></li>
            </ul>
            <b-link :href="`${appConfig.url}/storage/sample.xlsx`">
              دانلود فایل نمونه
            </b-link>
          </b-card-text>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, fileSize } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import {
  BCard,
  BCardTitle,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormFile,
  BSpinner,
  BLink,
  BCardText,
  BProgress,
} from 'bootstrap-vue'
import store from '@/store'
import DataTableLoader from '../../components/loaders/DataTableLoader'

export default {
  components: {
    DataTableLoader,
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BButton,
    BProgress,
    vSelect,
    BFormFile,
    BForm,
    BFormGroup,
    BCardText,
    BSpinner,
    BLink,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: [String, Number],
      default: () => '',
    },
  },
  data() {
    return {
      loader: true,
      groups: [],
      file: null,
      fileProgress: 0,
      group: '',
      required,
      fileSize,
      spin: false,
    }
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
  },
  created() {
    this.getData()
    if (this.id !== undefined && this.id != null && this.id > 0) this.group = this.id.toString()
  },
  methods: {
    getData() {
      this.$http
        .get('groups', {
          params: {
            sort_key: 'id',
            sort_type: 'desc',
          },
        })
        .then(({ data }) => {
          this.loader = false
          this.groups = data.items
        })
        .catch(() => {
        })
    },
    importContacts() {
      this.$refs.importContactForm.validate().then(success => {
        if (success) {
          this.spin = true
          const config = {
            onUploadProgress: progressEvent => {
              this.fileProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              )
            },
          }
          const formData = new FormData()
          formData.append('csv_file', this.file)
          this.$http.post(`groups/${this.group}/import`, formData, config).then(({ message }) => {
            this.spin = false
            this.$router.push({ name: 'contacts' }).then(() => {
              this.showSuccessNotification(message)
            })
          }).catch(() => {
            this.spin = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
